import '../../css/custom_orders.scss';

import jquery from 'jquery';

jquery(() => {
  const $warningElement = jquery('#supplier_warning');
  const $warningElementText = jquery('#supplier_warning_text');
  const $inputElem = jquery('input[name="customer_order[supplier]"]');

  const handler = (): void => {
    const warning = jquery($inputElem.filter(':checked')[0]).data('warning');

    if (warning) {
      $warningElementText.text(warning);
      $warningElement.show();
    } else {
      $warningElement.hide();
    }
  };

  $inputElem.on('change', handler);
  handler();
});
